import { render, staticRenderFns } from "./QuickMoveInMapFilters.vue?vue&type=template&id=54c0aaff&"
import script from "./QuickMoveInMapFilters.vue?vue&type=script&lang=js&"
export * from "./QuickMoveInMapFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports